<div class="left-sidebar-wrapper">
  <app-facility-icon [logo]="'light'"></app-facility-icon>
  <div class="left-sidebar-body">
    <app-side-menu-item [(currentUrl)]="currentUrl"
                        [menu]="menuItems.directory"></app-side-menu-item>
  </div>
</div>
